export default __webpack_public_path__ + "static/media/user.f17fe334.svg";